module.exports = __webpack_public_path__ + "static/media/IMG_20150525_193944.85b19cde.jpg";